<template>
  <div>
    <div class="noContainer" v-if="channelCount === 0">
      <no-data :imgSrc="noImgSrc" text="暂无订单"></no-data>
    </div>
    <div class="container" v-else>
      <div class="contain">
        <buyListCell
          v-for="(item) in canUse"
          :key="item.index"
          :name="item.channel_name"
          :iconUrl="item.icon_url"
          :year="item.time"
          :byear="item.buy_times"
          :buyprice="item.channel_price"
          @preview="preview(item.channel_name,item.channel_price,item.serial_number,item.device,item.buy_time)"
        ></buyListCell>
      </div>
    </div>
  </div>
</template>
<script>
import BuyListCell from './components/BuyListCell.vue'
import Common from '../../assets/js/common.js'
import NoData from '../../components/NoData/NoData.vue'
import axios from 'axios'
import moment from 'moment'
var api = process.env.BASE_URL
var isLocal = Common.getEvn()
export default {
  components: {
    BuyListCell,
    NoData
  },
  data () {
    return {
      userId: localStorage.getItem('max_userId'),
      deviceId: localStorage.getItem('max_device_id'),
      imgSrc: Common.staticHref() + 'img/smallCanlender.jpg',
      noImgSrc: Common.staticHref() + 'img/icon_dd.png',
      channelCount: 0,
      allChannelLists: [],
      canUse: [],
      other: [],
      useId: [],
      useIdBase: []
    }
  },
  methods: {
    preview (name, price, number, device, buytime) {
      buytime = moment(buytime).format('YYYY-MM-DD HH:mm:ss')
      this.$router.push({
        path: '/BuyChannelDetail',
        query: {name, price, number, device, buytime}
      })
    },
    getChannels () {
      this.toast = this.$createToast({
        time: 0,
        txt: '正在加载',
        mask: true
      }).show()
      if (isLocal === 'local') {
        axios
          .post('/Calendar/api/factory/buy/goods/info/', {
            device_id: this.deviceId,
            user_id: this.userId
          })
          .then(this.getChannelsSucc)
          .catch(this.getChannelsErr)
      } else {
        axios
          .post(api + '/Calendar/api/factory/buy/goods/info/', {
            device_id: this.deviceId,
            user_id: this.userId
          })
          .then(this.getChannelsSucc)
          .catch(this.getChannelsErr)
      }
    },
    initChannelArr () {
      this.allChannelLists.splice(0, this.allChannelLists.length)
    },
    getChannelsSucc (res) {
      this.initChannes(res)
    },
    getChannelsErr (error) {
      this.toast.hide()
      console.log(error)
    },
    initChannes (res) {
      this.toast.hide()
      let _res = res.data
      if (!_res) return false
      if (_res.result === 0) {
        this.initChannelArr()
        this.channelCount = _res.infos.length
        if (this.channelCount === 0) return false
        this.allChannelLists = _res.infos
        this.allChannelLists.forEach((elem, i) => {
          elem.index = i
          elem.buy_times = moment(elem.buy_time).format('YYYY-MM-DD')
          this.canUse.push(elem)
        })
      } else {
        console.log(_res.message)
      }
    }
  },
  mounted () {
    Common.setTitle('购买记录')
    this.getChannels()
  }
}
</script>
<style lang="stylus" scoped>
@import '~styles/mixins.styl'

.container {
  position: relative;
  padding-top: 20px;
  box-sizing: border-box;
  colCenter();

  .contain {
    overflow: auto;
  }

  .type-name {
    color: #000000;
    font-size: 14px;
    padding-bottom: 12px;
  }

  .btn-save {
    bottom: 2.487vh;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/BuyList/BuyList.vue